const clearDublicateUtm = () => {
    const url = window.location.href;
    
    try {
        if (url.indexOf('?utm_') !== url.lastIndexOf('?utm_')) {
            // Нашли два набора UTM-меток
            let cleanUrl = url.split('?')[0] + '?' + url.split('?')[1];        
            history.replaceState(null, null, cleanUrl);
            console.log('Удалены дубликаты UTM меток');
        }
    } catch(e) {
        console.log(e);
    }
}

export default clearDublicateUtm;